import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    getOpenApiGetProductVariantsPriceIndexSignalsCountUrl,
    getOpenApiShowPriceIndexConnectTooltipUrl,
    OpenApiGetProductVariantsPriceIndexSignalsCountMethod,
    type OpenApiGetProductVariantsPriceIndexSignalsCountRequest,
    type OpenApiGetProductVariantsPriceIndexSignalsCountResponseSuccess,
    OpenApiShowPriceIndexConnectTooltipMethod,
    type OpenApiShowPriceIndexConnectTooltipRequest,
    type OpenApiShowPriceIndexConnectTooltipResponseSuccess,
} from '#shared/api/schema';

const priceIndexApi = createApi({
    name: 'entities/product/api/priceIndex',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            showConnectTooltip: builder.query<
                OpenApiShowPriceIndexConnectTooltipResponseSuccess,
                OpenApiShowPriceIndexConnectTooltipRequest
            >({
                query: () => {
                    return {
                        url: getOpenApiShowPriceIndexConnectTooltipUrl(),
                        method: OpenApiShowPriceIndexConnectTooltipMethod,
                    };
                },
            }),
            getCounts: builder.query<
                OpenApiGetProductVariantsPriceIndexSignalsCountResponseSuccess,
                OpenApiGetProductVariantsPriceIndexSignalsCountRequest
            >({
                query: () => {
                    return {
                        url: getOpenApiGetProductVariantsPriceIndexSignalsCountUrl(),
                        method: OpenApiGetProductVariantsPriceIndexSignalsCountMethod,
                    };
                },
            }),
        };
    },
});

export const useGetProductPriceIndexCounts = priceIndexApi.useGetCountsQuery;
export const useLazyShowProductPriceIndexConnectTooltip = priceIndexApi.useLazyShowConnectTooltipQuery;
